module.exports = __webpack_public_path__ + "img/Schedule-Consultation Icon Desktop.f25c7676.svg";